import { Segment } from '@dna/analytics'
import { WithProfiler } from '@dna/mixins'
import styles from '@dna/styles'
import { LitElement, css, html, nothing, when } from '@lit'

class DNACartToggle extends WithProfiler(LitElement) {
  static properties = {
    initialCount: {
      type: Number,
    },
    count: {
      type: Number,
    },
    showCount: {
      type: Boolean,
    },
  }

  constructor() {
    super()

    this.count = this.initialCount || 0
    this.showCount = !!customElements.get('sl-button')

    document.addEventListener('dna:cart:items-count', (event) =>
      this._handleItemsCountChange(event),
    )
  }

  willUpdate(changedProperties) {
    if (changedProperties.has('initialCount')) {
      this.count = this.initialCount
    }
  }

  connectedCallback() {
    super.connectedCallback()
    customElements.whenDefined('sl-button').then(() => {
      this.showCount = true
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    document.removeEventListener('dna:cart:items-count', this._handleItemsCount)
  }

  _handleItemsCountChange(event) {
    this.count = event.detail.count
  }

  openCart() {
    document.dispatchEvent(new CustomEvent('dna:cart:open'))

    // @segment
    Segment.protect(() => {
      Segment.track(Segment.CONSTANTS.EVENTS.CART_ICON_CLICKED)
    })
  }

  render() {
    return html`
      <sl-button
        variant="text"
        size="small"
        class="cart-toggle"
        @click=${this.openCart}
        role="button"
      >
        <slot name="bag-icon"></slot>
        <span class="cart-toggle__count">
           ${when(
             this.count > 0 && this.showCount,
             () => html`
              ${this.count}
            `,
             () => nothing,
           )}
        </span>
        <slot name="title"></slot>
      </sl-button>
    `
  }

  static styles = [
    styles.flex,
    styles.typography,
    css`
      .cart-toggle {
        position: relative;
        color: inherit;
        width: 24px;
        height: 24px;
        top: -2px;
      }
      .cart-toggle::part(base):hover,
      .cart-toggle::part(base):focus {
        color: var(--dna-color-reflex-blue);
      }
      .cart-toggle__count {
        color: var(--dna-toggle-text-color, var(--dna-color-midnight));
        position: absolute;
        top: 9px;
        left: 0;
        width: 100%;
        font-size: 10px;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: 0.5px;
        text-align: center;
      }
    `,
  ]
}

customElements.define('dna-cart-toggle', DNACartToggle)
